import { render, staticRenderFns } from "./UnSentInvoices.vue?vue&type=template&id=9a473766"
import script from "./UnSentInvoices.vue?vue&type=script&lang=js"
export * from "./UnSentInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports